import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { I18nWrapperProps } from '../../interfaces/i18n-wrapper-props';
import { Tooltip } from 'primereact/tooltip';

const transComponents = () => {
  return {
    italic: <i />,
    bold: <strong />,
    span: <span />,
    small: <small />,
    h1: <h1 />,
    h2: <h2 />,
    h3: <h3 />,
    h4: <h4 />,
    h5: <h5 />,
    h6: <h6 />,
    br: <br />,
    article: <article />,
    section: <section />,
    ul: <ul />,
    ol: <ol />,
    li: <li />,
    nbsp: <>&nbsp;</>,
  };
};
const I18nWrapper = ({
  prefix,
  tooltip,
  translateKey,
  ns,
  options,
}: I18nWrapperProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [pf, setPf] = useState<string>('');

  useEffect(() => {
    if (!prefix) return;
    setPf(`${prefix}.`);
  }, [prefix]);

  if (tooltip) {
    return (
      <>
        <Tooltip target={`#${translateKey.split('.').pop()}`} showDelay={150} />
        <span
          id={translateKey.split('.').pop()}
          data-pr-tooltip={t(tooltip).toString()}
        >
          <Trans
            i18nKey={pf + translateKey}
            values={options}
            components={transComponents()}
            ns={ns}
          />
        </span>
      </>
    );
  }

  return (
    <Trans
      i18nKey={pf + translateKey}
      id={pf + translateKey}
      values={options}
      components={transComponents()}
      ns={ns}
    />
  );
};

export default I18nWrapper;
